
export const orderDetailPdfType = {
  pdp: "ORDERPDFTYPE002"
};
export const orderDetailsStatus = {
  // confirmed: "ORDERSTATUSTOC10",
  close: "ORDERSTATUS09",
  loanApplying: "ORDERSTATUS10",
  loanApproved: "ORDERSTATUS11",
  loanRejected: "ORDERSTATUS12",

  pre_and_gear_sales_cancelled: "ORDERSTATUSTOC02",
  pre_sales_completed: "ORDERSTATUSTOC03",
  gear_sales_to_be_shipped: "ORDERSTATUSTOC04",
  gear_sales_shipped: "ORDERSTATUSTOC05",
  gear_sales_refunded: "ORDERSTATUSTOC06",
  bac_loan_applying: "ORDERSTATUSTOC07",
  bac_loan_approved: "ORDERSTATUSTOC08",
  bac_loan_rejected: "ORDERSTATUSTOC09",
  bac_order_confirmed: "ORDERSTATUSTOC10",
  bac_vehicle_dispatched: "ORDERSTATUSTOC11",
  bac_waiting_for_down_payment: "ORDERSTATUSTOC12",
  bac_waiting_for_final_payment: "ORDERSTATUSTOC13",
  ready_for_delivery: "ORDERSTATUSTOC14",
  delivering: "ORDERSTATUSTOC15",
  bac_delivered: "ORDERSTATUSTOC16",
  m2m_terminated: "ORDERSTATUSTOC17",
  m2m_subscription_ongoing: "ORDERSTATUSTOC20"
};
export const PdpSubscribeType = {
  buyACar: "SUBSCRIBETYPE001",
  monthToMonth: "SUBSCRIBETYPE002"
};
export const PdpTowBarType = {
  yes: "TOWBARSTATE01",
  no: "TOWBARSTATE02"
};
export const OrderSubType = {
  preSales: "ORDERSUBTYPE02",
  gear: "ORDERSUBTYPE01",
  vehicle: "ORDERSUBTYPE06"
};
export const ProductType = {
  gears: "PRODTYPE01",
  vehicle: "PRODTYPE02",
  tools: "PRODTYPE03",
  service: "PRODTYPE04"
};
export const PdpSpuType = {
  vehicle: "PRODUCTITEMTAG001",
  winterWheels: "PRODUCTITEMTAG002",
  wheelsService: "PRODUCTITEMTAG003",
  delivery: "PRODUCTITEMTAG004",
  servicePackage: "PRODUCTITEMTAG005",
  others: "PRODUCTITEMTAG006",
  towBar: "PRODUCTITEMTAG007",
  checkout: "PRODUCTITEMTAG008"
};
export const codeTypes = {
  activeAccount: "VERIFICATIONCODETYPE001",
  updateEmail: "VERIFICATIONCODETYPE002",
  updateMobile: "VERIFICATIONCODETYPE004"
};
export const _3dsStatus = {
  pendingHasLink: "PAYMENTTRANSACTIONSTATUS001",
  successNoLink: "PAYMENTTRANSACTIONSTATUS002",
  failed: "PAYMENTTRANSACTIONSTATUS003",
  orderCanceled: "PAYMENTTRANSACTIONSTATUS004",
  parSaleLoading: "PAYMENTTRANSACTIONSTATUS007"
};
export const dictTypes = {
  membership: "MEMBERSHIP",
  deliveryMethod: "DELIVERYMETHOD",
  orderStatus: "ORDERSTATUSTOC",
  orderType: "ORDERSUBTYPE",
  language: "LANGUAGE",
  idType: "IDTYPE",
  gender: "GENDER"
};
export const orderTypes = {
  gear: "ORDERSUBTYPE01",
  presale: "ORDERSUBTYPE02",
  monthToMonth: "ORDERSUBTYPE03",
  longTerm: "ORDERSUBTYPE04",
  buyACarLoan: "ORDERSUBTYPE05",
  buyACarCash: "ORDERSUBTYPE06"
};
export const printPdf = {
  preSaleConfirm: "presaleconfirm",
  gearsSale: "gearssale",
  gearConfirm: "gearconfirm"
};
export const planType = {
  BaC: "BaC",
  MtM: "MtM"
};
export const stockTypes = {
  BaC: 0,
  MtM: 1
};
export const financingTab = {
  LOAN: "LOAN",
  CASH: "CASH"
};
export const touchPointType = {
  BaC: "TOUCHPOINTTYPE01",
  MtM: "TOUCHPOINTTYPE02"
};
export const exCodes = {
  phoneExists: "USER_CUSTOMER_026"
};
export const PickupInStoreCode = "DELIVERYMETHOD01";
export const InstantCode = "DELIVERYMETHOD04";
export const DefaultStoreCode = "Store01";
export const siteErrorCodes = {
  clubNotSelected: "EX_CLUB_NOT_SELECTED",
  orderNotFound: "EX_ORDER_NOT_FOUND",
  loanLinkMissing: "EX_PDP_LOAN_LINK_MISSING"
};
export const addressTypes = {
  shipping: 3
};
export const orderCodes = {
  success: "1",
  failed: "PAYMENT_EXCEPTION_010",
  mainOrderNotExist: "ORDER_EXCEPTION_0001",
  subOrderNotExist: "SUBORDER_EXCEPTION_0001",
  paymentNotExist: "ORDER_EXCEPTION_0004"
};
export const bankCardSubTypes = {
  actived: "BANKCARDSUBTYPE01",
  others: "BANKCARDSUBTYPE02"
};
